/* DSA sectie C: slider zonder externe libraries (scroll-snap) */
if (!customElements.get('dsa-c-slider')) {
  class DsaCSlider extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.dsa-c-track');
      if (!this.track) return;
      this.prev = this.querySelector('[data-dsa-prev]');
      this.next = this.querySelector('[data-dsa-next]');
      this.dotsEl = this.querySelector('.dsa-c-slider__dots');
      this.onScroll = () => this.update();
      this.track.addEventListener('scroll', this.onScroll, { passive: true });
      if (this.prev) this.prev.addEventListener('click', () => this.go(-1));
      if (this.next) this.next.addEventListener('click', () => this.go(1));
      this.track.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowRight') { e.preventDefault(); this.go(1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); this.go(-1); }
      });
      this.resizeObserver = new ResizeObserver(() => this.build());
      this.resizeObserver.observe(this.track);
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.setupAutoplay();
      this.build();
    }
    disconnectedCallback() {
      if (this.resizeObserver) this.resizeObserver.disconnect();
      clearInterval(this.timer);
    }
    get slides() { return Array.from(this.track.children); }
    get step() {
      const s = this.slides;
      if (s.length < 2) return this.track.clientWidth;
      return s[1].offsetLeft - s[0].offsetLeft;
    }
    build() {
      const scrollable = this.track.scrollWidth > this.track.clientWidth + 2;
      this.dataset.scrollable = scrollable ? 'true' : 'false';
      if (this.dotsEl) {
        const pages = scrollable ? this.slides.length : 0;
        if (this.dotsEl.children.length !== pages) {
          this.dotsEl.innerHTML = '';
          for (let i = 0; i < pages; i++) {
            const b = document.createElement('button');
            b.type = 'button';
            b.className = 'dsa-c-slider__dot';
            b.setAttribute('aria-label', 'Ga naar dia ' + (i + 1));
            b.addEventListener('click', () => this.to(i));
            this.dotsEl.appendChild(b);
          }
        }
      }
      this.update();
    }
    index() { return Math.round(this.track.scrollLeft / (this.step || 1)); }
    to(i) {
      const slide = this.slides[Math.max(0, Math.min(i, this.slides.length - 1))];
      if (!slide) return;
      this.track.scrollTo({ left: slide.offsetLeft - this.slides[0].offsetLeft, behavior: this.reduced ? 'auto' : 'smooth' });
    }
    go(dir) {
      const max = this.track.scrollWidth - this.track.clientWidth;
      if (dir > 0 && this.track.scrollLeft >= max - 2) { this.to(0); return; }
      this.to(this.index() + dir);
    }
    update() {
      const max = this.track.scrollWidth - this.track.clientWidth;
      const loop = this.dataset.autoplay;
      if (this.prev) this.prev.disabled = this.track.scrollLeft <= 1;
      if (this.next) this.next.disabled = !loop && this.track.scrollLeft >= max - 2;
      if (this.dotsEl) {
        const atEnd = this.track.scrollLeft >= max - 2;
        const idx = atEnd ? this.slides.length - 1 : this.index();
        Array.from(this.dotsEl.children).forEach((d, n) => d.setAttribute('aria-current', n === idx ? 'true' : 'false'));
      }
    }
    setupAutoplay() {
      const seconds = parseInt(this.dataset.autoplay, 10);
      if (!seconds || this.reduced || (window.Shopify && window.Shopify.designMode)) return;
      let paused = false;
      ['mouseenter', 'focusin', 'touchstart'].forEach((ev) => this.addEventListener(ev, () => (paused = true), { passive: true }));
      ['mouseleave', 'focusout'].forEach((ev) => this.addEventListener(ev, () => (paused = false)));
      this.timer = setInterval(() => { if (!paused && !document.hidden && this.dataset.scrollable === 'true') this.go(1); }, seconds * 1000);
    }
  }
  customElements.define('dsa-c-slider', DsaCSlider);
}
